import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';
import AssignLessonActionWithDateSelectionV2 from '../../../../../lessons/lessonactions/lesson-multi-selection-actions/AssignLessonActionWithDateSelectionV2';
import { useTeacherCurriculum } from '../../../context/TeacherCurriculumContextProvider';
import {
  useReloadLessonsByUuids,
} from '../CurriculumLessonsHooks';

const defaultProps = {
  lessons: [],
  selectedLessonIds: [],
  isAssignAutoTag: true,
};
export default function TeacherCurriculumAssignLessonsAction(p) {
  const {
    lessons,
    selectedLessonIds,
    isAssignAutoTag,
  } = { ...defaultProps, ...filterUndefined(p) };
  const { teacherCurriculumDomain } = useTeacherCurriculum();
  const { reloadLessonsByUuids } = useReloadLessonsByUuids(teacherCurriculumDomain);
  const { lessonData } = teacherCurriculumDomain.domainData;
  const tags = isAssignAutoTag ? lessonData && lessonData.meta.tags : null;

  return (
    <AssignLessonActionWithDateSelectionV2
      lessons={lessons}
      selectedLessonIds={selectedLessonIds}
      buttonLabel='Assign'
      showAddToMyList
      reloadDataFunc={async () => {
        const lessonsToReload = lessons.filter((l) => selectedLessonIds.includes(l.id));
        await reloadLessonsByUuids(lessonsToReload);
      }}
      tagNameForAutoSaving={tags}
      objectiveType='CURRICULUM'
    />
  );
}
